import { useState, useEffect } from "react";
import api from "../services/apis";
import { DEMO_DATA } from "../utils/demoData";

const useFeatures = (code) => {
  const [features, setFeatures] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

   const demo = DEMO_DATA[code];

  useEffect(() => {
     if (demo) return;
    const fetchData = async () => {
      try {
        const response = await api.get(`api/v1/issues/userss/${code}`);
        const data = await response.data;
        setFeatures(data);
      } catch (err) {
        console.error("Error fetching features:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [code]);

  if (demo) return { features: demo.redFlag, loading: false, error: false };
  return { features, loading, error };
};

export default useFeatures;
